import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import type { Address } from 'viem';
import { InterfaceChainUtils, type VaultVersion } from '@morpho-org/dapp-core';
import { DataList } from '@morpho-org/ui-v6/client';
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { ArrowDiagonalUp } from '@repo/ui/icons';
import { memo } from 'react';
import { ButtonLink } from '@/components/common/ButtonLink';
const V1_LINK = 'https://github.com/morpho-org/metamorpho';
const V2_LINK = 'https://github.com/morpho-org/metamorpho-v1.1';
const versionToLink: Record<VaultVersion, string> = {
  'v1.0': V1_LINK,
  'v1.1': V2_LINK
};
export interface VaultVersionDataLineProps {
  chainId: ChainId;
  factoryAddress?: Address;
}
const VaultVersionDataLine = t0 => {
  const $ = _c(15);
  const {
    chainId,
    factoryAddress
  } = t0;
  if (!factoryAddress) {
    return null;
  }
  let t1;
  if ($[0] !== chainId || $[1] !== factoryAddress) {
    t1 = InterfaceChainUtils.getVaultVersionByAddress(chainId, factoryAddress);
    $[0] = chainId;
    $[1] = factoryAddress;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const vaultVersion = t1;
  if (!vaultVersion) {
    return null;
  }
  const link = versionToLink[vaultVersion];
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DataList.LeftItem label="Morpho vault version" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== vaultVersion) {
    t3 = <span className="text-foreground text-xs">{vaultVersion}</span>;
    $[4] = vaultVersion;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      variant: "ghost",
      size: "sm",
      iconRight: undefined,
      iconAlone: <ArrowDiagonalUp />,
      iconAloneProps: {
        className: "text-secondary-foreground"
      }
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== link) {
    t5 = <TooltipTrigger asChild={true}><div className="flex"><ButtonLink href={link} buttonProps={t4} /></div></TooltipTrigger>;
    $[7] = link;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TooltipContent>View source code on GitHub.</TooltipContent>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <Tooltip>{t5}{t6}</Tooltip>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t7) {
    t8 = <DataList.Line>{t2}<DataList.RightItem><div className="gap-2xs flex items-center">{t3}{t7}</div></DataList.RightItem></DataList.Line>;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default memo(VaultVersionDataLine);